export const GETALLBOARDS="/api/user/mylist";
export const DELETEBOARD="/api/resource/delete";
export const CREATEBOARD="/api/resource/create";
export const UPATEBOARD="/api/resource/update"
export const GETBOARDDETAILS="/api/resource"
export const UPDATEACCESSOFUSER="/api/resource/allocation/update"
export const ADDNEWUSERS="/api/resource/allocate"